import * as THREE from 'three'
require('three-orbitcontrols');

import tidepool_negx_2 from '@/3dapps/skybox/tidepool/negx_2.jpg';
import tidepool_negy_2 from '@/3dapps/skybox/tidepool/negy_2.jpg';
import tidepool_negz_2 from '@/3dapps/skybox/tidepool/negz_2.jpg';
import tidepool_posx_2 from '@/3dapps/skybox/tidepool/posx_2.jpg';
import tidepool_posy_2 from '@/3dapps/skybox/tidepool/posy_2.jpg';
import tidepool_posz_2 from '@/3dapps/skybox/tidepool/posz_2.jpg';

export var scene;//相机
export var camera;//场景
export var renderer;//渲染器
let currentMesh;
let renderCount = -1;

export function incRenderCount() {
    renderCount += 2;
}

function addSkyBox(scene, imgs) {
    new THREE.CubeTextureLoader().load(imgs, function (texture) { scene.background = texture; incRenderCount(); });
}

export function initThree(canvas) {
    let canvas_bound = canvas.getBoundingClientRect();
    let controls;
    scene = new THREE.Scene(); //相机

    //创建3D世界
    let w = canvas_bound.width;
    let h = canvas_bound.height;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true, //抗锯齿
        preserveDrawingBuffer: true, //3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#778A99")); //把渲染器的背景变成白色
    renderer.setPixelRatio(2);


    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(50, w / h, 0.1, 2200);

    //定义相机的x,y,z位置
    camera.position.set(-3.926199201616954, 250.38160840528522, 229.67411426374036);
    camera.lookAt(scene.position); //把相机的位置渲染到场景中


    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas);

    controls.addEventListener("change", function () {
        renderCount += 2;
        //console.log(camera.position.x, camera.position.y, camera.position.z);
    });

    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 20;
    controls.maxDistance = 1000;

    // let axesHelper = new THREE.AxesHelper(100);
    // scene.add(axesHelper);

    // 灯光
    function addLights() {
        // 平行光
        let dirLight3 = new THREE.DirectionalLight(0xffffff, 0.1);
        dirLight3.position.set(-130, -130, -130); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight3);
        // let dirLightHelper2 = new THREE.DirectionalLightHelper(dirLight3);
        // scene.add(dirLightHelper2);

        // 平行光
        let dirLight4 = new THREE.DirectionalLight(0xffffff, 0.3);
        dirLight4.position.set(0, 400, 400); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight4);
        // let dirLightHelper3 = new THREE.DirectionalLightHelper(dirLight4);
        // scene.add(dirLightHelper3);

        {
            // 平行光
            let dirLight4 = new THREE.DirectionalLight(0xffffff, 0.3);
            dirLight4.position.set(0, 200, -200); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
            scene.add(dirLight4);
            // let dirLightHelper3 = new THREE.DirectionalLightHelper(dirLight4);
            // scene.add(dirLightHelper3);
        }
        {
            // 平行光
            let dirLight4 = new THREE.DirectionalLight(0xffffff, 0.3);
            dirLight4.position.set(0, 400, 0); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
            scene.add(dirLight4);
            // let dirLightHelper3 = new THREE.DirectionalLightHelper(dirLight4);
            // scene.add(dirLightHelper3);
        }

        // 环境光
        let ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        scene.add(ambientLight);
    }
    addLights();

    addSkyBox(scene, [
        tidepool_negx_2,
        tidepool_posx_2,
        tidepool_posy_2,
        tidepool_negy_2,
        tidepool_negz_2,
        tidepool_posz_2,
    ]);

    //渲染场景
    function animate(now) {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
        if (renderCount > 0) {
            renderer.render(scene, camera);
            renderCount = 0;
        } else if (renderCount < 0) {
            renderer.render(scene, camera);
        }
    }
    animate(0);
}



// WEBPACK FOOTER //
// ./src/views/mobilPhoneShell3d/scripts/mobilPhoneShell.js